import DetailPage from "../components/DetailPage";
import { detailPages } from "../data/detailPages";

export default function LogisticsWarehouse() {
  return <DetailPage data={detailPages["logistics-warehouse"]} />;
}
